import { ToastContainer, toast } from "react-toastify";
import {
  isValidPassword,
  isValidUsername,
  isMatchingPasswords,
  isValidEmail,
} from "../utils/formValidation";
import submitFormData from "../utils/formSubmit";
import { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from 'react-router-dom';

function Register() {

  const [formData, setFormData] = useState({
    displayName: "",
    username: "",
    email: "",
    dateOfBirth: "",
    password: "",
    passwordCopy: "",
  });

  const navigate = useNavigate();

  const handleFormInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateFormData = () => {

    if (!isValidUsername(formData.username)) {
      toast.error(
        "Invalid username. Only lower case letters, numbers, and underscores allowed."
      );
      return;
    }

    if (!isValidEmail(formData.email)) {
      toast.error("Invalid email address.");
      return;
    }

    if (!isValidPassword(formData.password)) {
      toast.error(
        "Invalid password. Include at least one uppercase letter, one lowercase letter, and one number."
      );
      return;
    }

    if (!isMatchingPasswords(formData.password, formData.passwordCopy)) {
      toast.error("Passwords do not match.");
      return;
    }

    submitFormData(formData)
      .then((response) => { navigate('/login') })
      .catch((error) => {
        if (error.message === "timeout of 5000ms exceeded") {
          toast.error("Unable to register at this time. Please try again later!");
        }

        else if (error.response && error.response.data.message) {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Unable to register at this time. Please try again later.");
        }
        
      }
      );
  };

  return (
    <div
      style={{
        backgroundColor: "#87CEEB",
        minHeight: "100vh",
        padding: 0,
        margin: 0,
      }}
    >
      <center>
        <h3>Welcome to your new future.</h3>
      </center>
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div
                className="card-body"
                style={{ backgroundColor: "", borderRadius: "5px" }}
              >
                <h2 className="card-title text-center mb-4">Register</h2>
                <form>
                  <div className="mb-3">
                    <label htmlFor="displayName" className="form-label">
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="displayName"
                      name="displayName"
                      placeholder="Justin Time"
                      onChange={handleFormInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="username" className="form-label">
                      Username
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="username"
                      name="username"
                      placeholder="jtime123"
                      onChange={handleFormInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="name"
                      name="email"
                      placeholder="justin.time@example.com"
                      onChange={handleFormInputChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="birthdate" className="form-label">
                      Date of Birth
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="dateOfBirth"
                      name="dateOfBirth"
                      onChange={handleFormInputChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <span style={{ fontSize: 'smaller',  display: 'block', marginBottom: '10px'}}>
                    Password must include at least one uppercase letter, one lowercase letter, and one number.
                    </span>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      name="password"
                      placeholder="********"
                      onChange={handleFormInputChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="passwordCopy"
                      name="passwordCopy"
                      placeholder="********"
                      onChange={handleFormInputChange}
                    />
                  </div>
                  <button
                    type="button"
                    onClick={validateFormData}
                    className="btn btn-primary w-100"
                  >
                    Sign Up
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}

export default Register;
